export enum ConfidenceLevel {
  LOW = 'low',
  HIGH = 'high',
}

export type IdentityJustificationTypeItem = {
  _id: string
  label: string
  confidenceLevel: ConfidenceLevel
}
